module.exports = __webpack_public_path__ + "img/services-apps-icon.40326009.svg";